// extracted by mini-css-extract-plugin
export default {"fadeWaiting":"Loading_fadeWaiting__GGtaj","fadeIn":"Loading_fadeIn__3AYcJ"};